import * as React from "react";
import "./styles.css";
import {useEffect,useState} from "react";
import {HOME_ACTION_CLEAR, HOME_ACTION_PERSIST} from "../../redux/Home/home.constant";
import {persist} from "../../redux/actions";
import {useDispatch, useSelector} from "react-redux";
import {IFRAME_ACTION_CLEAR} from "../../redux/Iframe/iframe.constant";
import {GAME_USER_PROFILE_ACTION_CLEAR} from "../../redux/GameUserProfile/gameUserProfile.constant";
import {GAME_USER_LOGIN_ACTION_CLEAR} from "../../redux/GameUserLogin/gameUserLogin.constant";
import {LIFE_STONE_ACTION_CLEAR} from "../../redux/LifeStone/lifeStone.constant"
import {GROUP_ACTION_CLEAR} from "../../redux/Group/group.constant"
import {CHAT_ACTION_CLEAR} from "../../redux/Chat/chat.constant"
import {LEADERBOARD_ACTION_CLEAR} from "../../redux/Leaderboard/leaderboard.constant"
import {OFFER_WALL_ACTION_CLEAR} from "../../redux/OfferWall/offerwall.constant"
import {STORE_ACTION_CLEAR} from "../../redux/Store/store.constant"

import  {GetUser , UpdateUser} from "../../Util/user";
import {showAds} from "../../Util/Ads";
import {showLoading,Util,PageLayout} from "baziigram";
import {STORAGE_KEY} from "../../constants"

const GamePageLayout = ({ children , type , style}) => {

    const {lastTime} = useSelector(state => state.home);
    const [user,setUser] = useState(null)
    const mainPages = [HOME_ACTION_CLEAR,IFRAME_ACTION_CLEAR,GAME_USER_PROFILE_ACTION_CLEAR,"ABOUT_US" , "AWARDS"]
     useEffect(() => {
     checkTime()
     setUser(GetUser())
     if(Util.getLanguage()=="en")
     document.getElementsByTagName('body')[0].classList.add("playfair")

     else
     document.getElementsByTagName('body')[0].classList.remove("playfair")

         window.addEventListener('message',postMessageListener)
         window.addEventListener('back-is-clicked', clearState);
        return () => {
            window.removeEventListener('message',postMessageListener)
            window.removeEventListener('back-is-clicked', clearState);
        };
    }, []);

     let dispatch = useDispatch()

   const checkTime=()=>{
            let d = (new Date()).getTime()
            let lastTime = Util.Storage.get(STORAGE_KEY.LAST_TIME) || 0
            if(d - lastTime > 15*60*1000 || isNaN(d - lastTime)) {
               clearAll()
              Util.Storage.save(STORAGE_KEY.LAST_TIME , d)
            }

       }

    const clearState=(event)=>{
    if(type)
    dispatch(persist(null , type))

    }

    const clearAll=()=>{
        dispatch(persist(null , HOME_ACTION_CLEAR))
        dispatch(persist(null , IFRAME_ACTION_CLEAR))
        dispatch(persist(null , GAME_USER_PROFILE_ACTION_CLEAR))
        dispatch(persist(null , GAME_USER_LOGIN_ACTION_CLEAR))
        dispatch(persist(null , LIFE_STONE_ACTION_CLEAR))
        dispatch(persist(null , GROUP_ACTION_CLEAR))
        dispatch(persist(null , CHAT_ACTION_CLEAR))
        dispatch(persist(null , LEADERBOARD_ACTION_CLEAR))
        dispatch(persist(null , OFFER_WALL_ACTION_CLEAR))
        dispatch(persist(null , STORE_ACTION_CLEAR))

    }

    const postMessageListener=(e)=>{

        if(e.origin.indexOf("https://games.baziigram.com")>-1  ||
            e.origin.indexOf("https://levels.baziigram.com")>-1 ) {
            if(e.data=="getUser")
            {
            let u = user || GetUser()
                if(u && Object.keys(u).length>0 )
                replyMessage(e,u)

            }

            else if(e.data.message=="showVideoAd")
            showAds(()=>replyMessage(e , "endAd"),e.data.gameId)


            else if(e.data.message=="showInterstitialAd")
            showAds(()=>replyMessage(e , "endAd"),e.data.gameId)

            else if(e.data.message=="showAudioBtn" && document.getElementById("mute-btn"))
             document.getElementById("mute-btn").style.display = e.data.display

            else if(typeof e.data === "object")
            UpdateUser(e.data)

        }
    }




const replyMessage=(e, msg)=>{
if( e.origin.indexOf("https://games.baziigram.com")>-1)
document.getElementsByName('baziigramFrame')[0].contentWindow.postMessage(msg,"https://games.baziigram.com")

else if( e.origin.indexOf("https://levels.baziigram.com")>-1)
 document.getElementsByName('baziigramFrame')[0].contentWindow.postMessage(msg,"https://levels.baziigram.com")

}


    return (<PageLayout className={mainPages.indexOf(type)>-1?"main-background":"night-background"}  style={Object.assign({},{overflowY:"auto" , overflowX:"hidden"},style)}>
    {mainPages.indexOf(type)==-1  && <>
    {(!user || user.theme!="day") && <img  className={"w-100 jungle"} src ="/images/main-page/back3.png"/>}
    {user && user.theme=="day" && <img  className={"w-100 light-jungle"} src ="/images/main-page/image (2).png"/>}
     </>
     }
    {children}</PageLayout>);
};

export default GamePageLayout;
